import React, {forwardRef, type ReactNode} from 'react';
import type {HTMLAttributes, SpringTooling} from '../__SharedTypes';

export type StackItemProps = {
  /**
   * Contents of the StackItem.
   */
  children?: ReactNode;
} & HTMLAttributes &
  SpringTooling;

export const StackItem = forwardRef<HTMLElement, StackItemProps>(
  ({...props}: StackItemProps, ref) => {
    /**
     * This is to solve a CSS Flexbox rendering bug(?).
     *
     * Child elements that have a more responsive layout (width) may
     * have their `width` CSS ignored by Flex if the contents of the
     * Flexbox container get too "squishy".
     *
     * @see https://webflow.atlassian.net/browse/PDTY-2509
     */
    // @ts-expect-error - TS2322 - Type 'ForwardedRef<HTMLElement>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
    return <div {...props} ref={ref} />;
  }
);

StackItem.displayName = 'StackItem';

export default StackItem;
